import { render } from "./AsDivider.vue?vue&type=template&id=7bea9ee7"
const script = {}

import "./AsDivider.vue?vue&type=style&index=0&id=7bea9ee7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__